import component from "js/legacy/unavailable-noop"

export default component
